// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageLinkBlock_container__y7D2G","link":"ImageLinkBlock_link__K8tRM","image":"ImageLinkBlock_image__14tB7","tooltip":"ImageLinkBlock_tooltip__uVr74"};